(function() {
  function defineProductModal() {
    if (customElements.get('product-modal')) return; // Already defined
    if (typeof ModalDialog === 'undefined') return; // ModalDialog not available yet
    
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.sliderInitialized = false;
        this.sliderselector = '.product-media-modal__content';
        this.mainGalleryViewer = null;
        this.slideChangeHandler = null;
      }

      connectedCallback() {
        super.connectedCallback();
        this.findMainGallery();
        this.setupClickPrevention();
      }

      setupClickPrevention() {
        // Prevent modal from closing when clicking on images, slider content, or any modal content
        // Only allow closing via the close button
        this.addEventListener('pointerup', (event) => {
          // Check if click is on the close button - allow it to close
          if (event.target.closest('[id^="ModalClose-"]')) {
            return; // Let the close button handler work
          }
          
          // Prevent closing for all other clicks (images, slider, content, etc.)
          event.stopImmediatePropagation();
        }, true); // Use capture phase to intercept before parent handler
        
        // Also prevent click events
        this.addEventListener('click', (event) => {
          // Only allow close button clicks
          if (!event.target.closest('[id^="ModalClose-"]')) {
            event.stopImmediatePropagation();
          }
        }, true);
      }

      findMainGallery() {
        // Extract section ID from modal ID (format: ProductModal-{sectionId})
        const modalId = this.id;
        const sectionId = modalId.replace('ProductModal-', '');
        
        // Find the main gallery viewer for this section
        const gallerySelector = `#GalleryViewer-${sectionId}`;
        const galleryViewer = document.querySelector(gallerySelector);
        
        if (galleryViewer) {
          this.mainGalleryViewer = galleryViewer;
          // Listen to slide changes in the main gallery
          this.slideChangeHandler = this.syncWithMainGallery.bind(this);
          galleryViewer.addEventListener('slideChanged', this.slideChangeHandler);
        }
      }

      syncWithMainGallery(event) {
        // Only sync if modal is open and slider is initialized
        if (!this.open || !this.sliderInitialized) {
          return;
        }
        
        if (event && event.detail && event.detail.currentElement) {
          const activeMediaId = event.detail.currentElement.getAttribute('data-media-id');
          if (activeMediaId) {
            this.goToMediaId(activeMediaId);
          }
        }
      }

      getActiveMediaFromMainGallery() {
        if (!this.mainGalleryViewer) {
          this.findMainGallery();
        }
        
        if (this.mainGalleryViewer) {
          // The mainGalleryViewer is the slider-component element
          const sliderComponent = this.mainGalleryViewer;
          
          // Try to access slider component properties directly
          if (sliderComponent.currentPage !== undefined && sliderComponent.sliderItemsToShow) {
            const currentIndex = sliderComponent.currentPage - 1;
            
            if (sliderComponent.sliderItemsToShow[currentIndex]) {
              const activeSlide = sliderComponent.sliderItemsToShow[currentIndex];
              const mediaId = activeSlide.getAttribute('data-media-id');
              return mediaId;
            }
          }
          
          // Method 2: Calculate current page using the same logic as SliderComponent
          const slider = sliderComponent.querySelector('[id^="Slider-"]');
          
          if (slider) {
            // Get all slide items (filter out hidden ones)
            const sliderItems = Array.from(sliderComponent.querySelectorAll('[id^="Slide-"]')).filter(
              (element) => element.clientWidth > 0
            );
            
            if (sliderItems.length >= 2) {
              // Calculate sliderItemOffset (same as SliderComponent)
              const sliderItemOffset = sliderItems[1].offsetLeft - sliderItems[0].offsetLeft;
              
              // Calculate current page (same formula as SliderComponent.update())
              const currentPage = Math.round(slider.scrollLeft / sliderItemOffset) + 1;
              
              const currentIndex = currentPage - 1;
              if (sliderItems[currentIndex]) {
                const activeSlide = sliderItems[currentIndex];
                const mediaId = activeSlide.getAttribute('data-media-id');
                return mediaId;
              }
            }
          }
          
          // Fallback: Find the active slide by class
          const activeSlide = this.mainGalleryViewer.querySelector('.product__media-item.is-active');
          
          if (activeSlide) {
            const mediaId = activeSlide.getAttribute('data-media-id');
            return mediaId;
          }
        }
        
        return null;
      }

      hide() {
        super.hide();
        // Remove event listener when modal closes
        if (this.mainGalleryViewer && this.slideChangeHandler) {
          this.mainGalleryViewer.removeEventListener('slideChanged', this.slideChangeHandler);
        }
        
        // Destroy slick slider when modal closes to reset state
        if (this.sliderInitialized && typeof $ !== 'undefined') {
          const $slider = $(this.querySelector(this.sliderselector));
          if ($slider.length && $slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
            this.sliderInitialized = false;
          }
        }
      }

      show(opener) {
        super.show(opener);

        // Re-attach event listener when modal opens
        if (this.mainGalleryViewer && this.slideChangeHandler) {
          this.mainGalleryViewer.addEventListener('slideChanged', this.slideChangeHandler);
        }

        // Wait for modal to be fully visible before initializing slider
        // Use requestAnimationFrame to ensure DOM is ready, but no setTimeout delay
        requestAnimationFrame(() => {
          this.initializeSlider(() => {
            // Callback after slider is initialized
            this.showActiveMedia();
          });
        });
      }

      initializeSlider(callback) {
        if (typeof $ === 'undefined' || typeof $.fn.slick === 'undefined') {
          if (callback) callback();
          return;
        }

        const sliderElement = this.querySelector(this.sliderselector);
        if (!sliderElement) {
          if (callback) callback();
          return;
        }

        const $slider = $(sliderElement);

        if (!$slider.hasClass('slick-initialized')) {
          try {
            // Store callback to call after init
            const initCallback = () => {
              this.sliderInitialized = true;
              
              // Use requestAnimationFrame instead of setTimeout for immediate execution
              requestAnimationFrame(() => {
                if (callback) callback();
              });
            };
            
            // Attach init event listener BEFORE calling slick()
            $slider.on('init', initCallback);
            
            // Initialize slick
            $slider.slick({
              infinite: false,
              speed: 300,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              fade: false,
              adaptiveHeight: true,
              prevArrow: '<button type="button" class="slick-prev product-modal-arrow"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 1L2 8L9 15" stroke="currentColor" stroke-width="1.5"/></svg></button>',
              nextArrow: '<button type="button" class="slick-next product-modal-arrow"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L8 8L1 15" stroke="currentColor" stroke-width="1.5"/></svg></button>',
            });

            // Prevent modal close when clicking arrows or dots
            sliderElement.addEventListener('pointerup', (event) => {
              if (event.target.closest('.slick-arrow') || event.target.closest('.slick-dots')) {
                event.stopPropagation();
              }
            });

          } catch (error) {
            if (callback) callback();
          }
        } else {
          this.sliderInitialized = true;
          // If already initialized, call callback immediately
          if (callback) {
            requestAnimationFrame(() => {
              callback();
            });
          }
        }
      }

      goToMediaId(mediaId) {
        if (!mediaId) {
          return;
        }

        // Normalize media ID (handle potential "section-id-media-id" format)
        // Extract just the numeric media ID (last part after splitting by '-')
        const mediaIdParts = mediaId.split('-');
        const normalizedMediaId = mediaIdParts.length > 1 ? mediaIdParts[mediaIdParts.length - 1] : mediaId;

        // If slick is ready, go to the slide
        if (this.sliderInitialized && typeof $ !== 'undefined') {
          const $slider = $(this.querySelector(this.sliderselector));

          if ($slider.length && $slider.hasClass('slick-initialized')) {
            // Find index of the slide with matching data-media-id
            const $slides = $slider.find('.slick-slide');
            let slideIndex = -1;

            // Try to find matching slide - check multiple formats
            $slides.each(function (index) {
              const slideMediaIdAttr = $(this).attr('data-media-id');
              
              // Try multiple comparison methods:
              // 1. Exact match with original
              // 2. Exact match with normalized
              // 3. Check if normalized ID is contained in slide ID (for cases like "123" matching "section-123")
              // 4. Check if slide ID ends with normalized ID
              const exactMatch = slideMediaIdAttr == mediaId || slideMediaIdAttr == normalizedMediaId;
              const containsMatch = slideMediaIdAttr && slideMediaIdAttr.toString().endsWith(normalizedMediaId);
              const normalizedInSlide = slideMediaIdAttr && slideMediaIdAttr.toString().includes(normalizedMediaId);
              
              if (exactMatch || containsMatch || normalizedInSlide) {
                slideIndex = index;
                return false; // break loop
              }
            });

            if (slideIndex >= 0) {
              $slider.slick('slickGoTo', slideIndex, true); // true = no animation
              
              // Handle deferred media loading for the active slide
              const activeSlide = $slides.eq(slideIndex)[0];
              if (activeSlide) {
                const activeMedia = activeSlide.querySelector('deferred-media');
                if (activeMedia) {
                  const activeMediaTemplate = activeMedia.querySelector('template');
                  const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
                  if (activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
                    activeMedia.loadContent();
                  }
                }
              }
            }
          }
        } else {
          // Fallback for non-slider view (if any)
          const activeSlide = this.querySelector(`[data-media-id="${normalizedMediaId}"]`) || 
                             this.querySelector(`[data-media-id="${mediaId}"]`);
          if (activeSlide) activeSlide.scrollIntoView();
        }
      }

      showActiveMedia() {
        // Priority 1: Use the clicked button's media-id (most reliable)
        let activeMediaId = null;
        if (this.openedBy) {
          activeMediaId = this.openedBy.getAttribute('data-media-id');
        }
        
        // Priority 2: Fallback to active slide from main gallery if no clicked button
        if (!activeMediaId) {
          activeMediaId = this.getActiveMediaFromMainGallery();
        }
        
        if (!activeMediaId) {
          return;
        }

        // Find the position/index of this media-id in the modal slider and navigate to it
        this.goToMediaId(activeMediaId);
      }
    }
    );
  }

  // Wait for ModalDialog to be defined
  function waitForModalDialog() {
    if (typeof ModalDialog !== 'undefined') {
      defineProductModal();
    } else {
      // Check if DOM is ready, then wait a bit for global.js to execute
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(waitForModalDialog, 50);
        });
      } else {
        setTimeout(waitForModalDialog, 50);
      }
    }
  }

  // Start waiting for ModalDialog
  if (!customElements.get('product-modal')) {
    waitForModalDialog();
  }
})();
